import store from '@/store'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

export const getAllContractors = async () => {
  const contractors = await store.dispatch(actions.callApi, { url: 'contractors' })
  store.commit(mutations.SET_CONTRACTORS, contractors)
}

export const createNewContractor = async (data) => {
  const contractor = await store.dispatch(
    actions.callApi,
    {
      url: data.id ? `contractors/${data.id}` : 'contractors',
      method: data.id ? 'put' : 'post',
      body: {
        ...data,
        address: undefined
      }
    }
  )
  store.commit(mutations.ADD_CONTRACTOR, contractor)
  store.dispatch(actions.createMessage, { text: 'Contractor created', color: 'success' })
  return contractor
}

export const deleteContractor = async (id) => {
  await store.dispatch(
    actions.callApi,
    {
      url: `contractors/${id}`,
      method: 'delete'
    }
  )
  store.dispatch(actions.createMessage, { text: 'Employer saved', color: 'success' })
}
